<div class="dish-list" cdkDropList (cdkDropListDropped)="dropProduct($event)">
  <app-menu-section-product *ngFor="let product of products"
                            [currency]="currency"
                            [product]="product"
                            [originalProduct]="getOriginalProduct(product)"
                            (editProduct)="onOpenEditDialogProduct($event)"
                            [menuSection]="menuSection"
                            [currentOrganization]="currentOrganization"
                            [cdkDragData]="product"
                            [menuPipes]="menuPipes"
                            [showKioskWarning]="showKioskWarning"
                            [canEditProduct]="canEditProduct"
                            [cdkDragDisabled]="!allowOverrides"
                            cdkDrag
                            class="drag-box">
    <div *cdkDragPlaceholder class="product-drag-placeholder"></div>
  </app-menu-section-product>
</div>
